function countdown(targetDate){
  var second = 1000, 
  minute = second * 60, 
  hour = minute * 60, 
  day = hour * 24,
  countDown = new Date(targetDate).getTime(),
  x = setInterval(function() {    
    var now = new Date().getTime(), distance = countDown - now;

    document.getElementById("days").innerText = Math.floor(distance / (day)),
    document.getElementById("hours").innerText = Math.floor((distance % (day)) / (hour)),
    document.getElementById("minutes").innerText = Math.floor((distance % (hour)) / (minute)),
    document.getElementById("seconds").innerText = Math.floor((distance % (minute)) / second);

    if (distance < 0) {         
      clearInterval(x);
    }

  }, 0);
};


function countdownTimer(targetDate) {
  console.log('timer', targetDate);
  var millisecond = 1;
  var second = 1000;
  var minute = second * 60;
  var hour = minute * 60;
  var day = hour * 24;

  //let targetDate = "{{ $component_data['date'] ?? 'Apr 18, 2021 00:00:00 PST' }}";
  var countDown = new Date(targetDate).getTime();

  var secondTicker = 0;
  var minuteTicker = 0;
  var seconds = 0;

  var secondPercent = 0;
  var minutePercent = 0;
  var hourPercent = 0;
  var dayPercent = 0;


  var cSecond = 0;
  var cMinute = 0;
  var cHour = 0;
  var cDay = 0;

  var prevSecond = 1;

  var x = setInterval(function () {

    var now = new Date().getTime();
    var distance = countDown - now;

    cSecond = Math.floor((distance % minute) / second);
    cMinute = Math.floor((distance % hour) / minute);
    cHour = Math.floor((distance % day) / hour);
    cDay = Math.floor(distance / day);


    if (prevSecond > 0 && prevSecond > cSecond) {

      prevSecond--;
      secondPercent = cSecond / 60;
      minutePercent = cMinute / 60;
      hourPercent = cHour / 24;
      dayPercent = cDay / 42;

      //console.log(cSecond, cMinute, minutePercent);
    } else {
      prevSecond = 60;
    }

    update(secondPercent - 1);
    updateMinutes(minutePercent - 1);
    updateHours(hourPercent - 1);
    updateDays(dayPercent - 1);

    (document.getElementById("days").innerText = Math.floor(distance / day)),
    (document.getElementById("hours").innerText = Math.floor((distance % day) / hour)),
    (document.getElementById("minutes").innerText = Math.floor((distance % hour) / minute)),
    (document.getElementById("seconds").innerText = Math.floor((distance % minute) / second));

    //do something later when date is reached
    if (distance < 0) {
      console.log("Countdown Done.");
      clearInterval(x);
    }

  }, 20);

  /////////////////////////////////
  // SVG GARBAGE BEGIN //
  ////////////////////////////////


  var wrapper = document.getElementById('progressSeconds');
  var wrapperMinutes = document.getElementById('progressMinutes');
  var wrapperHours = document.getElementById('progressHours');
  var wrapperDays = document.getElementById('progressDays');
  var start = 0;
  var end = parseFloat(wrapper.dataset.percentage);

  var wrapperPar = document.getElementById('seconds');
  var wrapperParSize = wrapperPar.offsetWidth;
  var sizeCalc = (wrapperParSize + 11) / 2;

  var props = {
    fill: '#25bbd9',
    track: '#0b3b4e',
    stroke: '#010714',
    trackWidth: 12,
    strokeSpacing: 1,
    radius: sizeCalc,
    fillStart: '#3ff2a2',
    fillEnd: '#1ca3f9',
  }

  var radius = props.radius;
  var border = props.trackWidth;
  var strokeSpacing = props.strokeSpacing;
  var endAngle = Math.PI * 2;
  //var formatText = d3.format('.0%');
  var boxSize = radius * 2;
  var count = end;
  var progress = start;
  var step = end < start ? -0.01 : 0.01;

  //Define the circle
  var circle = d3.svg.arc()
    .startAngle(0)
    .innerRadius(radius)
    .outerRadius(radius - border);

  //setup SVG wrapper
  var svg = d3.select(wrapper)
    .append('svg')
    .attr('width', boxSize)
    .attr('height', boxSize);

  //BEGIN FILL GRADIENT
  var lg = svg.append("defs").append("linearGradient")
    .attr("id", "mygrad")
    .attr("x1", "0%")
    .attr("x2", "0%")
    .attr("y1", "0%")
    .attr("y2", "100%");
  lg.append("stop")
    .attr("offset", "0%")
    .style("stop-color", props.fillStart)
    .style("stop-opacity", 1)

  lg.append("stop")
    .attr("offset", "100%")
    .style("stop-color", props.fillEnd)
    .style("stop-opacity", 1)
  //END FILL GRADIENT

  // ADD Group container
  var g = svg.append('g')
    .attr('transform', 'translate(' + boxSize / 2 + ',' + boxSize / 2 + ')');

  //Setup track
  var track = g.append('g').attr('class', 'radial-progress');
  track.append('path')
    .attr('class', 'radial-progress__background')
    .attr('fil', "url(#mygrad)")
    .attr('stroke', props.stroke)
    .attr('stroke-width', 10 + 'px')
    .attr('d', circle.endAngle(endAngle));

  //Add colour fill
  var value = track.append('path')
    .attr('class', 'radial-progress__value')
    .attr('fil', "url(#mygrad)")
    .attr('stroke', props.stroke)
    .attr('stroke-width', props.strokeSpacing + 'px');

  function update(progress) {
    //update position of endAngle
    if (value) {
      value.attr('d', circle.endAngle(endAngle * progress));
    }

  }


  //Define the circle
  var circleMinutes = d3.svg.arc()
    .startAngle(0)
    .innerRadius(radius)
    .outerRadius(radius - border);

  //setup SVG wrapper
  var svgMinutes = d3.select(wrapperMinutes)
    .append('svg')
    .attr('width', boxSize)
    .attr('height', boxSize);

  // ADD Group container
  var gMinutes = svgMinutes.append('g')
    .attr('transform', 'translate(' + boxSize / 2 + ',' + boxSize / 2 + ')');

  //Setup track
  var trackMinutes = gMinutes.append('g').attr('class', 'radial-progress');
  trackMinutes.append('path')
    .attr('class', 'radial-progress__background')
    .attr('fil', "url(#mygrad)")
    .attr('stroke', props.stroke)
    .attr('stroke-width', 10 + 'px')
    .attr('d', circleMinutes.endAngle(endAngle));

  //Add colour fill
  var valueMinutes = trackMinutes.append('path')
    .attr('class', 'radial-progress__value')
    .attr('fil', "url(#mygrad)")
    .attr('stroke', props.stroke)
    .attr('stroke-linecap', 'round')
    .attr('stroke-width', props.strokeSpacing + 'px');

  function updateMinutes(progressMinutes) {
    //update position of endAngle
    valueMinutes.attr('d', circleMinutes.endAngle(endAngle * progressMinutes));
  }




  //Define the circle
  var circleHours = d3.svg.arc()
    .startAngle(0)
    .innerRadius(radius)
    .outerRadius(radius - border);

  //setup SVG wrapper
  var svgHours = d3.select(wrapperHours)
    .append('svg')
    .attr('width', boxSize)
    .attr('height', boxSize);

  // ADD Group container
  var gHours = svgHours.append('g')
    .attr('transform', 'translate(' + boxSize / 2 + ',' + boxSize / 2 + ')');

  //Setup track
  var trackHours = gHours.append('g').attr('class', 'radial-progress');
  trackHours.append('path')
    .attr('class', 'radial-progress__background')
    .attr('fil', "url(#mygrad)")
    .attr('stroke', props.stroke)
    .attr('stroke-width', 10 + 'px')
    .attr('d', circleHours.endAngle(endAngle));

  //Add colour fill
  var valueHours = trackHours.append('path')
    .attr('class', 'radial-progress__value')
    .attr('fil', "url(#mygrad)")
    .attr('stroke', props.stroke)
    .attr('stroke-width', props.strokeSpacing + 'px');

  function updateHours(progressHours) {
    //update position of endAngle
    valueHours.attr('d', circleHours.endAngle(endAngle * progressHours));
  }


  //Define the circle
  var circleDays = d3.svg.arc()
    .startAngle(0)
    .innerRadius(radius)
    .outerRadius(radius - border);

  //setup SVG wrapper
  var svgDays = d3.select(wrapperDays)
    .append('svg')
    .attr('width', boxSize)
    .attr('height', boxSize);

  // ADD Group container
  var gHours = svgDays.append('g')
    .attr('transform', 'translate(' + boxSize / 2 + ',' + boxSize / 2 + ')');

  //Setup track
  var trackDays = gHours.append('g').attr('class', 'radial-progress');
  trackDays.append('path')
    .attr('class', 'radial-progress__background')
    .attr('fil', "url(#mygrad)")
    .attr('stroke', props.stroke)
    .attr('stroke-width', 10 + 'px')
    .attr('d', circleDays.endAngle(endAngle));

  //Add colour fill
  var valueDays = trackDays.append('path')
    .attr('class', 'radial-progress__value')
    .attr('fil', "url(#mygrad)")
    .attr('stroke', props.stroke)
    .attr('stroke-width', props.strokeSpacing + 'px');

  function updateDays(progressDays) {
    //update position of endAngle
    valueDays.attr('d', circleDays.endAngle(endAngle * progressDays));
  }
};